import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { useNavigate } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import GeralTable from "./ColaboradoresTabela";
import APIAxios from "../../Api/APIAxios";
import Autocomplete from "@mui/material/Autocomplete";
import PageTitle from "../../components/Layout/PageTitle";


const ColaboradoresListar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(4); //Jornadas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();
  const Navigate = useNavigate();

  const [cmpSelecao, setCmpSelecao] = useState(20); // default: descrição
  const [colaboradores, setColaboradores] = useState([]);
  const [jornadas, setJornadas] = useState([]); // <-- NOVO
  const [valorSelecionado, setValorSelecionado] = useState(""); // NOVO


  const handleListarTudo = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setAvisoErro("");

    try {
      const [respColabs, respJornadas] = await Promise.all([
        GetAPI(apiAxios, "/colabs"),
        GetAPI(apiAxios, "/calendarios"),
      ]);

      if (!respColabs.success) {
        throw new Error(
          respColabs.errorMessage || "Erro ao listar colaboradores"
        );
      }
      if (!respJornadas.success) {
        throw new Error(respJornadas.errorMessage || "Erro ao listar jornadas");
      }

      setColaboradores(respColabs.data || []);
      setJornadas(respJornadas.data || []);
    } catch (err) {
      setAvisoErro(err.message || "Falha ao carregar dados");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleListarTudo();
  }, []);

  //Função para seleção de filtro
  const getAutocompleteOptions = () => {
    let options = [];

    switch (cmpSelecao) {
      case 10:
        options = colaboradores.map((colab) => colab.nome);
        break;
      case 20:
        options = colaboradores.map((colab) => colab.cargo);
        break;
      case 30:
        options = colaboradores.map((colab) => colab.grupo.nome);
        break;
      case 40:
        options = colaboradores
          .map((c) => {
            const j = jornadas.find((j) => j.id === c.idCalendario);
            return j?.descricao;
          })
          .filter(Boolean);
        break;

      default:
        return [];
    }

    const semRepeticao = [...new Set(options.filter(Boolean))];

    // Ordena de forma alfabética ou numérica
    return semRepeticao.sort((a, b) => {
      if (typeof a === "string") return a.localeCompare(b); // ordenação alfabética
      return a - b; // ordenação numérica
    });
  };

  // NOVO: Filtra conforme o valor selecionado
  const registrosFiltrados = valorSelecionado
    ? colaboradores.filter((colab) => {
        const valor = valorSelecionado.toLowerCase();
        switch (cmpSelecao) {
          case 10:
            return colab.nome.toLowerCase().includes(valor);
          case 20:
            return colab.cargo.toLowerCase().includes(valor);
          case 30:
            return colab.grupo.nome.toLowerCase().includes(valor);
          case 40: {
            const j = jornadas.find((j) => j.id === colab.idCalendario);
            return j?.descricao?.toLowerCase().includes(valor);
          }

          default:
            return true;
        }
      })
    : colaboradores;

  const handleIncluirColaborador = () => {
    Navigate("/colaborador/incluir");
  };

  return (
    <Box>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Colaboradores"
        subtitle="Listagem de Colaboradores"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}

      <Box sx={{ color: "red", marginBottom: 2 }}>
        <Grid container spacing={2} alignItems={"center"}>
          {/*Usar meia tela em caso de monitor grande e tela total em monitores pequenos*/}
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <FormControl fullWidth>
                <InputLabel>Filtrar por:</InputLabel>
                <Select
                  labelId="cmpSelecao"
                  id="cmpSelecao"
                  label="Filtrar por"
                  value={cmpSelecao}
                  onChange={(e) => setCmpSelecao(e.target.value)}
                >
                  <MenuItem value={10}>Nome</MenuItem>
                  <MenuItem value={20}>Cargo</MenuItem>
                  <MenuItem value={30}>Grupo</MenuItem>
                  <MenuItem value={40}>Jornada</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              id="cmpDescricao"
              freeSolo
              options={getAutocompleteOptions()}
              value={valorSelecionado}
              onInputChange={(event, newValue) => setValorSelecionado(newValue)} // NOVO
              renderInput={(params) => (
                <TextField {...params} label="Localizar" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ backgroundColor: "#1a3865" }}
              onClick={handleIncluirColaborador}
            >
              Incluir Colaborador
            </Button>
          </Grid>
        </Grid>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px", // ou use 100vh se for tela cheia
            }}
          >
            <CircularProgress size={50} />
          </Box>
        ) : (
          <GeralTable
            colaboradores={registrosFiltrados}
            setColaboradores={setColaboradores}
            jornadas={jornadas}
          /> // ALTERADO
        )}
      </Box>
    </Box>
  );
};

export default ColaboradoresListar;
